import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import { MAP_LAYER_IDS, MAP_MODES } from '../../../../lib/constants';
import AspectWheel from './AspectWheel';
import concat from 'lodash-es/concat';
import difference from 'lodash-es/difference';
import Panel from '../../Panel';
import styles from './AspectFilter.module.scss';

export function AspectFilter(props) {
  const changeValue = (value) => {
    if (props.aspectValues.includes(value)) {
      props.onChange(difference(props.aspectValues, [value]));
    } else {
      props.onChange(concat(props.aspectValues, value));
    }
  };

  return (
    <Panel title='Aspect' divider={true}>
      <div className={styles.pillGroup}>
        <AspectWheel
          activeValues={props.aspectValues}
          disabled={!props.toolEnabled}
          onToggle={changeValue}
        />
      </div>
    </Panel>
  );
}

AspectFilter.propTypes = {
  aspectValues: PropTypes.array,
  elevationLayer: PropTypes.object,
  is3d: PropTypes.bool,
  onChange: PropTypes.func,
  toolEnabled: PropTypes.bool,
};

export default connect((model) => {
  return {
    // aspectEnabled: model.terrain.enabledTools.includes('aspect'),
    // slopeEnabled: model.terrain.enabledTools.includes('slope'),
    elevationLayer: model.map.mapRef.findLayerById(MAP_LAYER_IDS.terrainAnalysis),
    is3d: model.map.mapMode === MAP_MODES.ThreeD,
    toolEnabled: model.terrain.preferences.terrainAnalysis.enabled,
  };
})(AspectFilter);
